const isProductExpired = (product) => {
  return (
    product?.doc_status?.toLowerCase() === 'expired' && product?.offer_inactive
  );
};

export default isProductExpired;
